import { usePage } from '@inertiajs/vue3'
import { Lingua } from '@/lingua'
import {computed} from 'vue'
import { trans } from 'trans-js'
export function useTranslate() {
    const page = usePage();
    const locale = computed(() => page.props?.locale || 'en'); // Fallback to 'en' if locale is undefined
    const configuration = computed(() => ({
        locale: locale.value,
        Lingua: Lingua
    }));

    const __t = (key, replace, config = configuration) => trans('site.' + key, replace, false, {
        Lingua: configuration.value.Lingua,
        locale: configuration.value.locale
    });

    return { __t };
}
